import { Menu, MenuButton, MenuItem, MenuItems, Label } from '@headlessui/react'
export type {
  MenuProps as HeadlessMenuProps,
  MenuButtonProps as HeadlessMenuButtonProps,
  LabelProps as HeadlessMenuLabelProps,
  MenuItemProps as HeadlessMenuItemProps,
  MenuItemsProps as HeadlessMenuItemsProps
} from '@headlessui/react'

export const HeadlessMenu = Object.assign(Menu, {
  Items: MenuItems,
  Item: MenuItem,
  Label: Label,
  Button: MenuButton
})
